<script>
import SideMenuItem from '../side-menu-item';
import Config       from '../../../../libs/config';

export default {
  name  : 'side-menu-item-service-list',
  mixins: [SideMenuItem],
  data  : function() {
    return {
      label    : 'サービス一覧',
      link     : Config.SERVICE_LINK.ATCOSME.SERVICE_LIST.SP.URL,
      analytics: { label: 'side_menu_item_atcosme_services' },
    };
  },
};
</script>
